<template>
  <div class="news-item">
    <div v-if="title" class="column news-item-top">
      <router-link
        :to="{ name: 'NewsDetails', params: { newsId: id } }"
        target="_blank"
        style="text-decoration: none"
      >
        <div class="title bold-font"><span v-html="title"></span></div>
      </router-link>
      <div class="row">
        <span class="date">{{
          t("search_news.published_on") + ": " + formatDate(date)
        }}</span>
      </div>
    </div>

    <div v-if="introduction" v-html="introduction" class="desc-short"></div>

    <div v-if="showMore && itemBody" id="item-body">
      <q-separator />
      <div v-html="itemBody" class="desc-body"></div>
    </div>

    <button
      @click="toggleShowMore()"
      class="show-more"
      :aria-expanded="showMore.toString()"
      aria-controls="item-body"
    >
      {{ showMore ? t("search_news.read_less") : t("search_news.read_more") }}
      <img
        class="svg-icon"
        :src="showMore ? chevronUp : chevronDown"
        :alt="showMore ? 'chevron up' : 'chevron down'"
      />
    </button>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import moment from "moment";
import newsService from "../../services/news.service";
import chevronDown from "@/assets/icons/chevron-down-solid.svg";
import chevronUp from "@/assets/icons/chevron-up-solid.svg";
export default {
  props: {
    newsTitle: String,
    intro: String,
    id: String,
    newsItem: Object,
    body: String,
  },
  setup(props) {
    const title = computed(() => {
      return props.newsTitle;
    });
    const introduction = computed(() => {
      return props.intro;
    });

    const date =
      props.newsItem.date != null
        ? moment(props.newsItem.date).format("YYYY-MM-DD")
        : null;
    const itemBody = ref(props.body);

    const showMore = ref(false);

    const toggleShowMore = () => {
      if (!showMore.value) {
        logNewsVisit();
      }
      showMore.value = !showMore.value;
    };

    const formatDate = (stringDate) => {
      const dateN = new Date(stringDate);
      return moment(dateN).format("DD-MM-YYYY");
    };

    const logNewsVisit = () => {
      newsService.recordVisitToNews(props.id);
    };

    return {
      title,
      introduction,
      showMore,
      date,
      itemBody,
      chevronDown,
      chevronUp,
      logNewsVisit,
      formatDate,
      toggleShowMore,
    };
  },
};
</script>
